import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'authHttpResourcePipe'
})
export class AuthHttpResourcePipe implements PipeTransform {

  constructor(
    private http: HttpClient,
  ) {}

  async transform(src: string): Promise<string> {

    const token: string = sessionStorage.getItem('jwtToken');
    const headers = new HttpHeaders({'Authorization': `Bearer ${token}`});
    const resourceBlob = await this.http.get(src, {headers, responseType: 'arraybuffer'}).toPromise();

    try {

      const reader = new FileReader();
      /* return new Promise((resolve, reject) => {
        reader.onloadend = () => resolve(reader.result as string);
        reader.readAsDataURL(resourceBlob);
      }); */

      let file = new Blob([resourceBlob], {type: 'application/pdf'});

      return new Promise((resolve, reject) => {
        reader.onloadend = () => resolve(reader.result as string);
        reader.readAsDataURL(file);
      });

    } catch {
      return '';
    }

  }

}